import {
  MessageSquare,
  Lightbulb,
  ShieldQuestion,
  UserCheck,
  Lock,
  Users2,
} from "lucide-react";

const TOPICS = [
  { icon: MessageSquare, label: "Gesprächsführung & Kommunikation" },
  { icon: Lightbulb, label: "Tarifverständnis & Energie" },
  { icon: ShieldQuestion, label: "Einwandbehandlung & Abschluss" },
  { icon: UserCheck, label: "Auftreten beim Bürger & Ethik" },
  { icon: Lock, label: "Datenschutz & Dokumentation" },
  { icon: Users2, label: "Teamentwicklung & Führung" },
];

export default function Academy() {
  return (
    <section
      id="akademie"
      data-testid="academy-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="relative rounded-3xl overflow-hidden bg-[#0A3B2C] text-white shadow-2xl">
          {/* Subtle decorative accents */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#10B981]/15 blur-3xl" />
            <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#10B981]/10 blur-3xl" />
          </div>

          <div className="relative p-8 md:p-14 lg:p-20">
            {/* Header row */}
            <div className="max-w-4xl">
              <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#10B981] mb-5">
                faktor-direkt Akademie
              </div>
              <h2
                className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.1] text-white mb-6"
                style={{ fontFamily: "Outfit, sans-serif" }}
                data-testid="academy-title"
              >
                Wir bilden Vertriebler aus, die regionale Versorger professionell vertreten können.
              </h2>
              <p className="text-base md:text-lg text-white/85 leading-relaxed max-w-3xl">
                Unsere Akademie stellt sicher, dass unsere Vertriebsmannschaft
                nicht nur abschließt, sondern berät, informiert und begeistert.
              </p>

              <div className="mt-6 inline-flex items-center gap-3 text-sm text-white/70">
                <span className="h-px w-10 bg-[#10B981]" />
                Praxisnah. Verständlich. Professionell.
              </div>
            </div>

            {/* Topics row at bottom */}
            <div className="mt-12 md:mt-16 pt-10 border-t border-white/10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-4">
              {TOPICS.map((t, i) => {
                const Icon = t.icon;
                return (
                  <div
                    key={i}
                    data-testid={`academy-topic-${i}`}
                    className="group flex flex-col items-start text-left"
                  >
                    <div className="h-12 w-12 rounded-xl bg-[#10B981]/15 border border-[#10B981]/25 flex items-center justify-center mb-4 group-hover:bg-[#10B981]/25 transition-colors">
                      <Icon className="h-5 w-5 text-[#10B981]" strokeWidth={2} />
                    </div>
                    <div className="text-sm font-semibold text-white leading-snug">
                      {t.label}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
